import { LoadableAfterPaint } from '@confluence/loadable';

export const PoweredByTemplates = LoadableAfterPaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-PoweredByTemplates" */ './PoweredByTemplates'))
			.PoweredByTemplates,
});
